import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const menu = (
    <>
      <li>
        <Link to="/">{`<Home/>`}</Link>
      </li>
      <li>
        <a href="#project">{`<Project/>`}</a>
      </li>

      <li>
        <a href="#skills"> {`<Skills/>`} </a>
      </li>
      <li>
        <a href="#about"> {`<About/>`} </a>
      </li>
      <li>
        <a href="#contact">{`<Contact/>`}</a>
      </li>
    </>
  );
  return (
    <div>
      <div className="navbar">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 md:hidden"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className=" menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              {menu}
            </ul>
          </div>
          <Link to="/" className="text-2xl">
            EMON
          </Link>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1">{menu}</ul>
        </div>
        <div className="navbar-end">
          <a
            target="_blank"
            href="https://drive.google.com/file/d/1lSb9vHKHEjrRLmeskNm_YaO7rtaVKdrt/view?usp=sharing"
            className=" bg-green-500 p-3 rounded-md text-white"
          >
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
